import React from 'react';

export default function Placeholder({ children, className }) {
  return (
    <span className={`text-muted font-italic ${className}`}>{children}</span>
  );
}
